/* prettier-ignore */
import { BrandsAnnies } from './_BrandsAnnies';
import { BrandsAutumnsGold } from './_BrandsAutumnsGold';
import { BrandsBLUE } from './_BrandsBLUE';
import { BrandsBTFE } from './_BrandsBTFE';
import { BrandsBellInstitute } from './_BrandsBellInstitute';
import { BrandsBettyCrocker } from './_BrandsBettyCrocker';
import { BrandsBugles } from './_BrandsBugles';
import { BrandsCTC } from './_BrandsCTC';
import { BrandsCascadianFarm } from './_BrandsCascadianFarm';
import { BrandsCheerios } from './_BrandsCheerios';
import { BrandsChexMix } from './_BrandsChexMix';
import { BrandsDunkaroos } from './_BrandsDunkaroos';
import { BrandsFiberOne } from './_BrandsFiberOne';
import { BrandsFruitRollUps } from './_BrandsFruitRollUps';
import { BrandsFruitbytheFoot } from './_BrandsFruitbytheFoot';
import { BrandsGMFS } from './_BrandsGMFS';
import { BrandsGMI } from './_BrandsGMI';
import { BrandsGardettos } from './_BrandsGardettos';
import { BrandsGoldMedal } from './_BrandsGoldMedal';
import { BrandsGushers } from './_BrandsGushers';
import { BrandsHD } from './_BrandsHD';
import { BrandsLarabar } from './_BrandsLarabar';
import { BrandsLuckyCharms } from './_BrandsLuckyCharms';
import { BrandsMLKBreakfast } from './_BrandsMLKBreakfast';
import { BrandsMorningSummit } from './_BrandsMorningSummit';
import { BrandsNatureValley } from './_BrandsNatureValley';
import { BrandsOEP } from './_BrandsOEP';
import { BrandsPillsbury } from './_BrandsPillsbury';
import { BrandsPizzaPops } from './_BrandsPizzaPops';
import { BrandsProgresso } from './_BrandsProgresso';
import { BrandsSujataFoods } from './_BrandsSujataFoods';
import { BrandsTotinos } from './_BrandsTotinos';
import { BrandsWhiteLabel } from './_BrandsWhiteLabel';

import { ThemesAux1 } from './_ThemesAux1';
import { ThemesAux2 } from './_ThemesAux2';
import { ThemesPrimary } from './_ThemesPrimary';
import { ThemesSecondary } from './_ThemesSecondary';

import { GlobalMode1 } from './_GlobalMode1';

export type BrandType = typeof BrandsAnnies;
export type ThemeType = typeof ThemesAux1;
export type GlobalType = typeof GlobalMode1;

export const brandMap = {
  BrandsAnnies: BrandsAnnies,
  BrandsAutumnsGold: BrandsAutumnsGold,
  BrandsBLUE: BrandsBLUE,
  BrandsBTFE: BrandsBTFE,
  BrandsBellInstitute: BrandsBellInstitute,
  BrandsBettyCrocker: BrandsBettyCrocker,
  BrandsBugles: BrandsBugles,
  BrandsCTC: BrandsCTC,
  BrandsCascadianFarm: BrandsCascadianFarm,
  BrandsCheerios: BrandsCheerios,
  BrandsChexMix: BrandsChexMix,
  BrandsDunkaroos: BrandsDunkaroos,
  BrandsFiberOne: BrandsFiberOne,
  BrandsFruitRollUps: BrandsFruitRollUps,
  BrandsFruitbytheFoot: BrandsFruitbytheFoot,
  BrandsGMFS: BrandsGMFS,
  BrandsGMI: BrandsGMI,
  BrandsGardettos: BrandsGardettos,
  BrandsGoldMedal: BrandsGoldMedal,
  BrandsGushers: BrandsGushers,
  BrandsHD: BrandsHD,
  BrandsLarabar: BrandsLarabar,
  BrandsLuckyCharms: BrandsLuckyCharms,
  BrandsMLKBreakfast: BrandsMLKBreakfast,
  BrandsMorningSummit: BrandsMorningSummit,
  BrandsNatureValley: BrandsNatureValley,
  BrandsOEP: BrandsOEP,
  BrandsPillsbury: BrandsPillsbury,
  BrandsPizzaPops: BrandsPizzaPops,
  BrandsProgresso: BrandsProgresso,
  BrandsSujataFoods: BrandsSujataFoods,
  BrandsTotinos: BrandsTotinos,
  BrandsWhiteLabel: BrandsWhiteLabel,
};

export const themeMap = {
  ThemesAux1: ThemesAux1,
  ThemesAux2: ThemesAux2,
  ThemesPrimary: ThemesPrimary,
  ThemesSecondary: ThemesSecondary,
};

export const globalMap = {
  GlobalMode1: GlobalMode1,
};

export type Brands = keyof typeof brandMap;
export const ALL_BRANDS: Brands[] = Object.keys(brandMap) as Brands[];
export type Themes = keyof typeof themeMap;
export const ALL_THEMES: Themes[] = Object.keys(themeMap) as Themes[];
